import { render, staticRenderFns } from "./NotificationDropDown.vue?vue&type=template&id=8b5859d8&scoped=true"
import script from "./NotificationDropDown.vue?vue&type=script&lang=js"
export * from "./NotificationDropDown.vue?vue&type=script&lang=js"
import style0 from "./NotificationDropDown.vue?vue&type=style&index=0&id=8b5859d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5859d8",
  null
  
)

export default component.exports